import React, { useState, useEffect } from 'react'
import { Col, Row, Image, Collapse, Tabs, Card, Result } from 'antd'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import faqService from '../services/faqService';
import util from "../../src/utils/functions/custom"
import { Messages, Notify } from "../services/custom/Messages";
import {openNotification, ParagraphHeader} from '@seims/shared';
import logger, { recordError } from "../../src/utils/logService";
import { programmes} from "../utils/apiConstants";

const FAQ = () => {
    const [faqs, setFaqs] = useState([]);
    const [currentTab, setCurrentTab] = useState("events-tracker");
    const [currentTitle, setCurrentTitle] = useState("General");
    const [emptyResults, setEmptyResults] = useState(true);

    const { Panel } = Collapse;
    let path = '/';

    // Just load the programmes from API constants
    const tabList = programmes.filter(c=>c.active === true).map(p => { return { key: p.key, label: p.value } });
    tabList.unshift({
        key: "seims-public",
        label: "General",
    });

    useEffect(() => {
        loadFaqs();
    }, [])

    const loadFaqs = async (module = currentTab) => {
        let msg;
        try {
            const response = await faqService.getFaq(module);
            if (response && (response.status == 200)) {
                setFaqs(response.data);
                setEmptyResults(false);
                return;
            }
            else {
                setFaqs([]);
                setEmptyResults(true);
            }
        } catch (error) {
            msg = util.parseMessage(Messages.UPDATE_FAILURE, "Load FAQ");
            openNotification("Load FAQ", msg, Notify.ERROR);
            recordError(error);
        }
    };

    const onTabChange = (selected) => {
        const _title = tabList.find(t => t.key == selected)?.label;
        setCurrentTab(selected);
        setCurrentTitle(_title);
        loadFaqs(selected)
    };

    return (
        <>
        <Row justify="center" className="page-header" style={{ marginBottom: 10 }}>
        <Col xs={12} md={5}>
          <div>
            <Image
              style={{ textAlign: 'center' }}
              preview={false}
              src={require("../assets/faq.png")}
              alt="User Guides"
            />
          </div>
        </Col>
      </Row>
      <Row justify="center" style={{ paddingBottom: 30 }} className="faq-page public-portal-page">
        <Col lg={18} xs={24}>
          <ParagraphHeader header={"Frequently Asked Questions - " + currentTitle} />
            {/* <h1 className="center-align">
                {"Frequently Asked Questions - " + currentTitle}
            </h1> */}
            <div style={{ textAlign: "justify" }}>
                {"Do you have some questions? We are here to help you. Please have a look at the questions below"
                    + " and see if we can help you out. If you still have questions, please get in touch with us"
                    + " using the contact details listed in the footer"
                }
            </div>
            <Row> </Row>
            <div className="space"></div>
            <Tabs
                className=""
                // type="card"
                onChange={onTabChange}
                items={tabList}
                key="repo-table-1"
                defaultActiveKey='events-tracker'
            />

            <Collapse
                defaultActiveKey={["1"]}
                expandIcon={({ isActive }) =>
                    isActive ? <MinusOutlined /> : <PlusOutlined />
                }
                expandIconPosition="end"
            >
                {faqs.map((data) => {
                    return (<Panel header={data.question} key={data.key} className='ant-collapse-item faq-collapse-item faq-text'>
                        <div dangerouslySetInnerHTML={{ __html: data.answer }}></div>
                    </Panel>);
                })}

            </Collapse>
            <br />
            {emptyResults && (
                <Card
                    className="doc-repo-card-empty"
                    bordered={false}
                >
                    <div className="no-results center-align">
                        <Result
                            title="To be populated soon..."
                        />
                    </div>
                </Card>
            )}
       </Col>
       </Row>
        </>
    )
}
export default FAQ;
